import { InputHTMLAttributes, forwardRef } from 'react'
import { cn } from '@/lib/cn'

export interface CheckboxProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label?: string
  error?: string
  helperText?: string
}

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  ({ label, error, helperText, className, ...props }, ref) => {
    return (
      <div className="w-full">
        <div className="flex items-start">
          <div className="flex items-center h-5">
            <input
              ref={ref}
              type="checkbox"
              className={cn(
                'w-4 h-4 rounded transition-colors',
                'border-input text-primary accent-primary',
                'focus:ring-2 focus:ring-ring focus:ring-offset-0',
                props.disabled && 'bg-muted cursor-not-allowed',
                className
              )}
              {...props}
            />
          </div>

          {label && (
            <div className="ml-3">
              <label className="text-sm font-medium text-foreground">
                {label}
              </label>
              {helperText && !error && (
                <p className="text-sm text-muted-foreground">{helperText}</p>
              )}
            </div>
          )}
        </div>

        {error && (
          <p className="mt-1 text-sm text-destructive">{error}</p>
        )}
      </div>
    )
  }
)

Checkbox.displayName = 'Checkbox'
